import { Navigate } from 'react-router-dom';

import AppLayout from 'layouts/app-layout/app-layout';
import PrivateRoute from './private-route';
import PublicRoute from './public-route';
import SignInPage from 'pages/signin';
import TermsPage from 'pages/terms';
import PrivacyPage from 'pages/privacy';
import BalancesPage from 'pages/balances';
import SummaryPage from 'pages/summary';
import PlantPage from 'pages/plant';
import RetirePage from 'pages/retire';
import CertificatesPage from 'pages/certificates';
import RetireActivityPage from 'pages/retire-activity';
import ActivityPage from 'pages/activity';
import DelegatePage from 'pages/delegate';
import DelegateSinglePage from 'pages/single-delegate';
import NotFound from 'pages/not-found';

import {
  SIGNIN_PAGE,
  TERMS_PAGE,
  PRIVACY_PAGE,
  BALANCES_PAGE,
  NOT_FOUND_PAGE
} from 'site-settings/site-navigation';

const routes = [
  {
    path: BALANCES_PAGE,
    element: <AppLayout />,
    children: [
      {
        path: BALANCES_PAGE,
        element: (
          <PrivateRoute>
            <BalancesPage />
          </PrivateRoute>
        )
      }
    ]
  },
  {
    path: BALANCES_PAGE,
    element: <AppLayout />,
    children: [
      {
        path: 'summary',
        element: (
          <PrivateRoute>
            <SummaryPage />
          </PrivateRoute>
        )
      },
      {
        path: 'plant',
        element: (
          <PrivateRoute>
            <PlantPage />
          </PrivateRoute>
        )
      },
      {
        path: 'retire',
        element: (
          <PrivateRoute>
            <RetirePage />
          </PrivateRoute>
        )
      },
      {
        path: 'certificates',
        element: (
          <PrivateRoute>
            <CertificatesPage />
          </PrivateRoute>
        )
      },
      {
        path: 'retire-activity',
        element: (
          <PrivateRoute>
            <RetireActivityPage />
          </PrivateRoute>
        )
      },
      {
        path: 'activity',
        element: (
          <PrivateRoute>
            <ActivityPage />
          </PrivateRoute>
        )
      },
      {
        path: 'delegate',
        element: (
          <PrivateRoute>
            <DelegatePage />
          </PrivateRoute>
        )
      },
      {
        path: 'delegate/:name',
        element: (
          <PrivateRoute>
            <DelegateSinglePage />
          </PrivateRoute>
        )
      },
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to={NOT_FOUND_PAGE} /> }
    ]
  },
  {
    path: BALANCES_PAGE,
    children: [
      {
        path: SIGNIN_PAGE,
        element: (
          <PublicRoute>
            <SignInPage />
          </PublicRoute>
        )
      }
    ]
  },
  // Public legal pages — available signed-in or out (open via target=_blank).
  {
    path: TERMS_PAGE,
    element: <TermsPage />
  },
  {
    path: PRIVACY_PAGE,
    element: <PrivacyPage />
  }
];

export default routes;
